import styled, { keyframes } from 'styled-components';
import { COLOURS, isFocused, media } from '@belong/themes';
import { Stack } from '../../ui/Stack/Stack';

export const StyledStack = styled(Stack)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div<{ isLightColor?: boolean }>`
  position: relative;
  width: 3.2rem;
  height: 3.2rem;
  border: 0.4rem solid;
  border-color: ${COLOURS.BELONG_BLUE_DARK} rgb(0, 0, 0, 25%) rgb(0, 0, 0, 25%);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${Rotation} 0.8s linear infinite;

  &::before,
  &::after {
    position: absolute;
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    display: inline-block;
    border-radius: 50%;
    background: ${COLOURS.BELONG_BLUE_DARK};
  }

  &::before {
    top: 0;
    left: 0;
  }

  &::after {
    top: 0;
    right: 0;
  }

  ${media('md')`
    width: 6.4rem;
    height: 6.4rem;
    border-width: 0.8rem;

    &::before,
    &::after {
      width: 0.8rem;
      height: 0.8rem;
    }
  `}

  @media (prefers-reduced-motion) {
    animation: ${Rotation} 5s linear infinite;
  }
`;

export const InlineSpinner = styled.div`
  position: relative;
  width: 3.2rem;
  height: 3.2rem;
  border: 0.4rem solid;
  border-color: ${COLOURS.BELONG_BLUE_DARK} rgb(0, 0, 0, 25%) rgb(0, 0, 0, 25%);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${Rotation} 0.8s linear infinite;
  flex-shrink: 0;

  &::before,
  &::after {
    position: absolute;
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    display: inline-block;
    border-radius: 50%;
    background: ${COLOURS.BELONG_BLUE_DARK};
  }

  &::before {
    top: 0;
    left: 0;
  }

  &::after {
    top: 0;
    right: 0;
  }

  @media (prefers-reduced-motion) {
    animation: ${Rotation} 5s linear infinite;
  }
`;

export const InlineSpinnerContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: auto;
  gap: ${({ theme }): string => `${theme.spaces.xsmall}${theme.cssUnit}`};
  white-space: normal;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  ${media('sm')`
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  `}
`;

export const InlineSpinnerText = styled.span`
  display: inline-block;
  white-space: inherit;
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;

  /* Visible focus outline for programmatic focus (a11y requirement) */
  &&:focus {
    ${isFocused()};
  }
`;
